import { CalendarCheck, FileText, Stethoscope, Heart } from 'lucide-react';
import { WHATSAPP_URL_PROC } from '../constants';
import { useScrollReveal } from '../hooks/useScrollReveal';

const steps = [
{
  number: '01',
  icon: CalendarCheck,
  title: 'Consulta Especializada',
  desc: 'Avaliação clínica completa, explicação sobre a condição, alinhamento de expectativas e planejamento personalizado.',
  detail: 'Duração: 30-40 minutos',
  result: 'Diagnóstico confirmado e avaliação da indicação cirúrgica',
  color: '#0D47A1'
},
{
  number: '02',
  icon: FileText,
  title: 'Pré-Operatório',
  desc: 'Realização de exames pré-operatórios e consulta com anestesista enquanto aguarda a autorização do plano de saúde ou orçamento particular.',
  detail: 'Instruções sobre suspensão de medicações e tempo de jejum',
  result: 'Tudo pronto para a cirurgia',
  color: '#00897B'
},
{
  number: '03',
  icon: Stethoscope,
  title: 'Simpatectomia Torácica',
  desc: 'Você dorme sob acompanhamento de um anestesista experiente. Duas pequenas incisões, câmera de alta definição, secção das fibras nervosas responsáveis pelo suor.',
  detail: 'Duração: 30-60 minutos',
  result: 'Você já acorda sem o problema',
  color: '#0D47A1'
},
{
  number: '04',
  icon: Heart,
  title: 'Recuperação Rápida',
  desc: 'Alta hospitalar pode ocorrer no mesmo dia ou na manhã seguinte. Sem restrições definitivas após algumas semanas.',
  detail: '3-5 dias para trabalho administrativo',
  result: 'Retorno ao trabalho ou escola em dias',
  color: '#00897B'
}];


export default function ProcedureSection() {
  const [ref, isVisible] = useScrollReveal();
  return (
    <section id="procedimento" ref={ref} className={`py-24 md:py-32 bg-white transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
      <div className="max-w-7xl mx-auto px-4 lg:px-8">

        <div className="max-w-3xl mx-auto text-center mb-16">
          <div className="inline-flex items-center bg-[#00897B]/10 text-[#00897B] rounded-full px-4 py-1.5 text-sm font-semibold mb-4">
            Como Funciona
          </div>
          <h2 className="font-poppins font-bold text-3xl sm:text-4xl text-[#212121] mb-6 leading-tight">
            Como Funciona o Tratamento
          </h2>
          <p className="text-base md:text-lg text-[#212121]/70 leading-relaxed">
            A simpatectomia torácica é um procedimento cirúrgico minimamente invasivo que remove as fibras
            nervosas simpáticas responsáveis pelo suor excessivo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {steps.map((step, i) => {
            const Icon = step.icon;
            return (
              <div
                key={i}
                data-testid={`procedure-step-${i + 1}`}
                className="relative bg-[#F5F5F5] rounded-2xl p-6 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 group">

                {/* Connector line (desktop) */}
                {i < steps.length - 1 &&
                <div className="hidden lg:block absolute top-10 -right-3 w-6 h-0.5 bg-gray-200 z-10" />
                }

                <div className="flex items-center gap-3 mb-4">
                  <div
                    className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: `${step.color}15` }}>

                    <Icon size={20} style={{ color: step.color }} />
                  </div>
                  <span
                    className="font-poppins font-bold text-2xl"
                    style={{ color: `${step.color}30` }}>

                    {step.number}
                  </span>
                </div>

                <h3 className="font-poppins font-bold text-lg text-[#212121] mb-2">
                  {step.title}
                </h3>
                <p className="text-[#212121]/65 text-sm leading-relaxed mb-4">
                  {step.desc}
                </p>

                <div className="border-t border-gray-200 pt-3 space-y-1">
                  <div className="text-xs text-[#212121]/50 font-medium">{step.detail}</div>
                  <div
                    className="text-xs font-semibold"
                    style={{ color: step.color }}>

                    {step.result}
                  </div>
                </div>
              </div>);

          })}
        </div>

        <div className="text-center">
          <a
            href={WHATSAPP_URL_PROC}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="procedure-cta-button"
            className="inline-flex items-center gap-2 bg-[#0D47A1] text-white font-poppins font-bold px-10 py-4 rounded-full hover:bg-[#00897B] transition-colors duration-200 shadow-lg hover:-translate-y-0.5 hover:shadow-xl">QUERO SABER MAIS


          </a>
        </div>

      </div>
    </section>);

}